import { isEmpty } from 'ramda';
import React, { FC } from 'react';
import { NoResults } from './NoResults/NoResults';
import { OtherCategoriesResults } from './OtherCategoriesResults/OtherCategoriesResults';
import { IOuter } from './MediaFromWix.types';

export const MediaFromWix: FC<IOuter> = ({
  header,
  searchQuery,
  items,
  onItemClick,
  selectedItems,
  isItemSelected,
  buyItem,
  onItemRightClick,
  isSecure,
  publicMediaCurrentCategory,
  publicMediaRootCategories,
  openExpandedView,
  currentFolder,
}) => (
  <div>
    {header}
    {!isEmpty(items) ? (
      <OtherCategoriesResults
        items={items}
        searchQuery={searchQuery}
        onItemClick={onItemClick}
        selectedItems={selectedItems}
        isItemSelected={isItemSelected}
        buyItem={buyItem}
        onItemRightClick={onItemRightClick}
        isSecure={isSecure}
        publicMediaCurrentCategory={publicMediaCurrentCategory}
        publicMediaRootCategories={publicMediaRootCategories}
        openExpandedView={openExpandedView}
        currentFolder={currentFolder}
      />
    ) : (
      <NoResults searchQuery={searchQuery} />
    )}
  </div>
);
